import { FRONTEND_SETTINGS_DEFAULTS, SITE_SETTINGS_DEFAULTS, } from './site_settings';
/**
 * This function makes sure that all of the needed keys are present in the
 * site settings object that we retrieve from the backend.
 * If we remove a site settings there can be a period of time where the backend
 * returns less keys than the front-end expects. If that happens the missing key is added with
 * the default value.
 *
 * @param settings The settings as retrieved from the backend.
 * @returns The frontend settings object with all the expected keys and default values
 * for the missing ones.
 */
export function frontendWithDefaults(settings) {
    return { ...FRONTEND_SETTINGS_DEFAULTS, ...settings };
}
/**
 * This function makes sure that all of the needed keys are present in the
 * site settings object that we retrieve from the backend.
 * If we remove a site settings there can be a period of time where the backend
 * returns less keys than the front-end expects. If that happens the missing key is added with
 * the default value.
 *
 * @param settings The settings as retrieved from the backend.
 * @returns The site settings object with all the expected keys and default values
 * for the missing ones.
 */
export function withDefaults(settings) {
    return { ...SITE_SETTINGS_DEFAULTS, ...settings };
}
